import { type BreadcrumbItem } from '@config'
import IconChevronRight from '@fortuneo/ui-icons/general/IconChevronRight'
import { useTrackNavigationLink } from '@hooks/use-track-navigation-link'
import { ENHANCED_COMPONENT_TYPE } from '@ui/enhanced-components/types'
import { Link as GatsbyLink } from 'gatsby-link'
import React, { type FC } from 'react'

import { BreadcrumbsStructuredData } from './breadcrumbs-structured-data'

type BreadcrumbsProps = {
  breadcrumbs: BreadcrumbItem[]
  isVisible?: boolean
  className?: string
}

export const Breadcrumbs: FC<BreadcrumbsProps> = ({
  breadcrumbs,
  isVisible = true,
  className,
}) => {
  const trackNavigationLink = useTrackNavigationLink()

  if (!breadcrumbs.length) {
    return null
  }

  return (
    <>
      <BreadcrumbsStructuredData breadcrumbs={breadcrumbs} />
      {isVisible && (
        <nav aria-label="breadcrumb" className={className}>
          <ol className="flex flex-wrap items-center py-2">
            {breadcrumbs.map(({ name, href }, index) => {
              const isLast = index === breadcrumbs.length - 1
              return href && !isLast ? (
                <li key={`breadcrumbs-link-${index}`}>
                  <GatsbyLink
                    className="text-085 hover:underline"
                    data-type={ENHANCED_COMPONENT_TYPE.HYPERLINK}
                    to={href}
                    onClick={trackNavigationLink}
                  >
                    {name}
                  </GatsbyLink>
                  <IconChevronRight
                    aria-hidden
                    style={{ fontSize: '1.31rem' }}
                  />
                </li>
              ) : (
                <li key={`breadcrumbs-link-${index}`}>
                  <span className="text-085">{name}</span>
                </li>
              )
            })}
          </ol>
        </nav>
      )}
    </>
  )
}
